export default "__VITE_PUBLIC_ASSET__bcedad17__"